import { ContactIcon, Pencil } from "../common/Icons";

export const MAX_WIDTH = {
  none: "",
  "lg-1200px": "max-width-lg",
  "xl-1400px": "max-width-xl",
  "xxl-1600px": "max-width-2xl",
};

export const IMAGE_POSITION = {
  NegativeTop: "negative-top",
  Top: "top",
  Center: "center",
  Bottom: "bottom",
  NegativeBottom: "negative-bottom",
};

export const ENDPOINTS = {
  medtech: "/api/medtech-forms",
  contact: "/api/contact-forms",
  sign_up: "/api/auth/local/register",
  sign_in: "/api/auth/local",
  video: "/api/on-demands",
  reset_password: "/api/auth/reset-password",
  forgot_password: "/api/auth/forgot-password",
  get_events: "/api/events",
  get_on_demand: "/api/on-demands",
  homepage: "/api/homepage",
  user_on_demands: "/api/users/me?populate=on_demands&populate=featuredImage",
};
